import { createRoot } from "react-dom/client";
import App from "./components/App";
import ReduxProvider from "./utils/ReduxProvider";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const container = document.getElementById("root"),
  root = createRoot(container);
root.render(
  <ReduxProvider>
    <App />
  </ReduxProvider>
);

serviceWorkerRegistration.register();
